import React from 'react'

function Request() {
    return (
        <div>
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfsitdK-PAUnGHu9SWNs2SgTmZvZL2KLSz11JCdUx0lPX6qjw/viewform?embedded=true" width="350" height="581" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        </div>
    )
}

export default Request